"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, label: s.name };
        });
    };
    DataStore.prototype.getAdvisorsArray = function (campusName) {
        var json = this.json;
        if (json.campuses) {
            for (var i = 0; i < json.campuses.length; i++) {
                if (json.campuses[i].name == campusName) {
                    return json.campuses[i].advisors;
                }
            }
        }
        console.log("Warning! No advisers found for campus=" + campusName);
        return null;
    };
    DataStore.prototype.getAllPrograms = function () {
        var json = this.json;
        var programs = [];
        if (json.programs) {
            programs = json.programs;
            programs.sort(function (a, b) {
                if (a.name < b.name)
                    return -1;
                if (a.name > b.name)
                    return 1;
                return 0;
            });
        }
        return programs;
    };
    DataStore.prototype.getAllCampuses = function () {
        var json = this.json;
        var campuses = [];
        if (json.campuses) {
            campuses = json.campuses;
            campuses.sort(function (a, b) {
                if (a.name < b.name)
                    return -1;
                if (a.name > b.name)
                    return 1;
                return 0;
            });
        }
        return campuses;
    };
    Object.defineProperty(DataStore.prototype, "marital_status", {
        get: function () {
            return [
                { value: "Married", label: "Married" },
                { value: "Single", label: "Single" },
                { value: "Divorced", label: "Divorced" },
                { value: "Widow", label: "Widow" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0YVN0b3JlLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZGF0YS9EYXRhU3RvcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTtJQUNJLG1CQUFvQixJQUFTO1FBQVQsU0FBSSxHQUFKLElBQUksQ0FBSztJQUFHLENBQUM7SUFFMUIsZ0NBQVksR0FBbkI7UUFDSSxJQUFNLE1BQU0sR0FBYyxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQTtRQUMxQyxPQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDO1lBQ2hCLE9BQU8sRUFBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLElBQUksRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDLElBQUksRUFBQyxDQUFBO1FBQ3pDLENBQUMsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQUVNLG9DQUFnQixHQUF2QixVQUF3QixVQUFVO1FBQzlCLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUE7UUFDcEIsSUFBSSxJQUFJLENBQUMsUUFBUSxFQUFFO1lBQ2YsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO2dCQUMzQyxJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxJQUFJLFVBQVUsRUFBRTtvQkFDckMsT0FBTyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQTtpQkFDbkM7YUFDSjtTQUNKO1FBRUQsT0FBTyxDQUFDLEdBQUcsQ0FBQyx3Q0FBd0MsR0FBRyxVQUFVLENBQUMsQ0FBQTtRQUNsRSxPQUFPLElBQUksQ0FBQTtJQUNmLENBQUM7SUFFTSxrQ0FBYyxHQUFyQjtRQUNJLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUE7UUFDcEIsSUFBSSxRQUFRLEdBQWdCLEVBQUUsQ0FBQTtRQUU5QixJQUFJLElBQUksQ0FBQyxRQUFRLEVBQUU7WUFDZixRQUFRLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQTtZQUN4QixRQUFRLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxFQUFFLENBQUM7Z0JBQ3hCLElBQUksQ0FBQyxDQUFDLElBQUksR0FBRyxDQUFDLENBQUMsSUFBSTtvQkFBRSxPQUFPLENBQUMsQ0FBQyxDQUFBO2dCQUM5QixJQUFJLENBQUMsQ0FBQyxJQUFJLEdBQUcsQ0FBQyxDQUFDLElBQUk7b0JBQUUsT0FBTyxDQUFDLENBQUE7Z0JBQzdCLE9BQU8sQ0FBQyxDQUFBO1lBQ1osQ0FBQyxDQUFDLENBQUE7U0FDTDtRQUVELE9BQU8sUUFBUSxDQUFBO0lBQ25CLENBQUM7SUFFTSxrQ0FBYyxHQUFyQjtRQUNJLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUE7UUFDcEIsSUFBSSxRQUFRLEdBQWUsRUFBRSxDQUFBO1FBRTdCLElBQUksSUFBSSxDQUFDLFFBQVEsRUFBRTtZQUNmLFFBQVEsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFBO1lBQ3hCLFFBQVEsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQztnQkFDeEIsSUFBSSxDQUFDLENBQUMsSUFBSSxHQUFHLENBQUMsQ0FBQyxJQUFJO29CQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUE7Z0JBQzlCLElBQUksQ0FBQyxDQUFDLElBQUksR0FBRyxDQUFDLENBQUMsSUFBSTtvQkFBRSxPQUFPLENBQUMsQ0FBQTtnQkFDN0IsT0FBTyxDQUFDLENBQUE7WUFDWixDQUFDLENBQUMsQ0FBQTtTQUNMO1FBRUQsT0FBTyxRQUFRLENBQUE7SUFDbkIsQ0FBQztJQUVELHNCQUFXLHFDQUFjO2FBQXpCO1lBQ0ksT0FBTztnQkFDSCxFQUFDLEtBQUssRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLFNBQVMsRUFBQztnQkFDcEMsRUFBQyxLQUFLLEVBQUUsUUFBUSxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUM7Z0JBQ2xDLEVBQUMsS0FBSyxFQUFFLFVBQVUsRUFBRSxLQUFLLEVBQUUsVUFBVSxFQUFDO2dCQUN0QyxFQUFDLEtBQUssRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBQzthQUNuQyxDQUFBO1FBQ0wsQ0FBQzs7O09BQUE7SUFFRCxzQkFBVyw2QkFBTTthQUFqQjtZQUNJLE9BQU87Z0JBQ0gsRUFBQyxLQUFLLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUM7Z0JBQzlCLEVBQUMsS0FBSyxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFDO2FBQ3JDLENBQUE7UUFDTCxDQUFDOzs7T0FBQTtJQUNMLGdCQUFDO0FBQUQsQ0FBQyxBQXZFRCxJQXVFQztBQXZFWSw4QkFBUyJ9